import { getCheckoutUrl, isProductionEnv } from '@shared/utils';
import Alert from "@util/alert.js";
import { submitCart } from '@shared/services';
import { guid, getTerminal } from '@shared/utils';
import { TERMINAL } from '@shared/constants';
export function beforeGoToCheckout(res = {}) {
  // 购买其他商品tips
  if (res.resultCode == "21063") {
    Alert.showConfirm({
      title: res.resultMsg || '',
      confirmText: "购买其他商品",
      confirm: function () {
        submitCart({ terminal: window._terminal, buyOther: true }).then(x => {
          window.location.href = getCheckoutUrl(true);
        }).catch(res => {
          Alert.showMessage("warning", res.resultMsg);
          $("#gocheckout").attr("disabled", null);
        })
      },
      cancelText: "返回修改"
    });
    return;
  }
  // 实名认证
  if (res.resultCode == "40051") {// 候补销售需要实名认证，跳转商详页
    // 请进行实名认证+URL_START+href+URL_END => 请进行实名认证URL_STARThttps://baiud.comURL_END
    const [msgTitle, startRight] = res?.resultMsg?.split('URL_START');
    const href = startRight?.split('URL_END')[0];
    Alert.showConfirm({
      title: msgTitle || '',
      confirmText: "去认证",
      confirm: function () { // 需要实名认证跳转到商详页
        let toAuthUrl = '';
        if (isProductionEnv()) {
          toAuthUrl = `https://activity.lenovo.com.cn/consumption_coupon/authentication.html?ru=${encodeURIComponent(href)}`;
        } else {
          toAuthUrl = `https://activity.lenovouat.com/consumption_coupon/authentication.html?ru=${encodeURIComponent(href)}`
        };
        window.location.href = toAuthUrl;
      }
    })
    return;
  }
  // 成功
  if (res?.resultCode == '0' || res?.success) {
    window.location.href = getCheckoutUrl();
    return;
  }
  Alert.showMessage("warning", res.resultMsg || '请稍后再试~'); // 兜底提示
}

/**
 * toast pc、wap通用
 * @param {String} msg 提示文案
 * @param {Number} time  提示展示时长
 * @param {Boolean} destory 是否清除之前toast
 */
export const toast = (msg = '', time = 2000, destory = true) => {
  const randomID = guid();
  const commonClass = '_comp_toast_traditional';
  const uniqueClass = `_comp_toast_traditional_${randomID}`;
  const isPC = getTerminal() == TERMINAL.PC;
  const html = `
      <div
      class='${commonClass} ${uniqueClass}'
      style="
          position: fixed;
          top: 50%;
          left: 50%;
          background-color: rgba(0,0,0,0.6);
          color: #fff;
          padding: ${isPC ? '10px' : '0.16rem 0.2rem'};
          border-radius: ${isPC ? '7px' : '0.07rem'};
          z-index: 99999;
          font-size: ${isPC ? '16px' : '0.16rem'};
          transform: translate(-50%, -50%);
          text-align: left;
          max-width: ${isPC ? '400px' : '80%'};
      ">
      ${msg}
      </div>
  `;
  if(destory) {
      document.querySelectorAll(`.${commonClass}`).forEach(dom => dom.remove());
  }
  $('body').append(html)
  setTimeout(() => {
      document.querySelector(`.${uniqueClass}`).remove();
  }, time);
}

